import EllipsisWithTooltip, { WidthContainer } from './ellipsis-with-tooltip';

export { WidthContainer };
export default EllipsisWithTooltip;
